import { FaLock } from "react-icons/fa";
import { FaCloud } from "react-icons/fa";
import { IoPersonSharp } from "react-icons/io5";
import { FaShieldAlt } from "react-icons/fa";
import RBI from "../assets/RBI-BW.svg";
import ISO from "../assets/ISO-BW.svg";
import PCI from "../assets/PCI-DSS-BW.svg";

export default function Securitysection(){
    return(
        <div className="bg-[#1d2736] mt-[140px] px-[10%] px-[10%] pt-20 pb-20 ">
        <p className="text-center font-bold text-3xl md:text-4xl text-white pb-10">Secure & Compliant</p>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-10 justify-center items-stretch max-w-6xl mx-auto">
          {/* Security Feature 1 */}
          <div className="text-white bg-[#333e4c] p-7 md:p-9 rounded-2xl flex flex-col items-center text-center shadow-lg min-h-[250px]">
            <FaLock className="text-[#27a887] text-5xl md:text-6xl mb-4" />
            <p className="text-xl md:text-2xl font-semibold">Multiple Layers of Protection</p>
            <p className="text-[#b0b4bb] text-sm md:text-base mt-2">Track payments in real-time with zero forex markup and complete cost transparency.</p>
          </div>
          
          {/* Security Feature 2 */}
          <div className="text-white bg-[#333e4c] p-7 md:p-9 rounded-2xl flex flex-col items-center text-center shadow-lg min-h-[250px]">
            <FaCloud className="text-[#27a887] text-5xl md:text-6xl mb-4" />
            <p className="text-xl md:text-2xl font-semibold">End-to-End Encryption</p>
            <p className="text-[#b0b4bb] text-sm md:text-base mt-2">All transactions and data are encrypted for maximum security.</p>
          </div>
          
          {/* Security Feature 3 */}
          <div className="text-white bg-[#333e4c] p-7 md:p-9 rounded-2xl flex flex-col items-center text-center shadow-lg min-h-[250px]">
            <IoPersonSharp className="text-[#27a887] text-5xl md:text-6xl mb-4" />
            <p className="text-xl md:text-2xl font-semibold">Audited by Experts</p>
            <p className="text-[#b0b4bb] text-sm md:text-base mt-2">Certified by CERT-IN empanelled auditors for robust security assurance.</p>
          </div>
        </div>
        
        {/* Compliance Section */}
        <div className="bg-[#333e4c] mt-10 rounded-2xl p-8 flex flex-col md:flex-row justify-center md:ml-[7.5%] md:mr-[7.5%] items-center gap-6 md:gap-10">
          <div className="flex items-center gap-x-4">
            <FaShieldAlt className="text-[#27a887] text-5xl md:text-6xl" />
            <p className="text-white text-center md:text-left max-w-[250px]">Fully compliant with RBI and Industry regulations</p>
          </div>
          <div className="flex flex-row gap-4 md:gap-10">
            <img src={RBI} className="w-auto max-w-[80px] sm:max-w-[100px]" loading="lazy"/>
            <img src={ISO} className="w-auto max-w-[80px] sm:max-w-[100px]" loading="lazy"/>
            <img src={PCI} className="w-auto max-w-[80px] sm:max-w-[100px]" loading="lazy"/>
          </div>
        </div>
      </div>

    )
}